// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"Du-z","expressButtonContainerWithPayPal":"Eu-z","expressButton":"Fu-z","or":"Gu-z"};